<!-- Error page layout -->
<template>
  <section class="p-4">
    <slot />
  </section>
</template>
